// Browser-safe accessors over the precompiled post/category data.
// No gray-matter/marked at runtime — everything is generated at build time.
import postsJson from './generated/posts.json'
import categoriesJson from './generated/categories.json'
import type { BlogPost, Category } from './types'

const posts = postsJson as unknown as BlogPost[]
const categories = categoriesJson as unknown as Category[]

export function getAllPosts(): BlogPost[] {
  return posts
}

export function getPostBySlug(slug: string): BlogPost | null {
  return posts.find((p) => p.slug === slug) ?? null
}

export function getAllCategories(): Category[] {
  return categories
}

export function getCategory(slug: string): Category | null {
  return categories.find((c) => c.slug === slug) ?? null
}

export function getPostsByCategory(slug: string): BlogPost[] {
  return posts.filter((p) => p.category === slug)
}

/**
 * Related posts: curated `internal_links` first, then same-category / shared-tag posts,
 * excluding the current post. Capped at `limit`.
 */
export function getRelatedPosts(post: BlogPost, limit = 3): BlogPost[] {
  const out: BlogPost[] = []
  const seen = new Set<string>([post.slug])
  const push = (p: BlogPost | null) => {
    if (p && !seen.has(p.slug)) {
      seen.add(p.slug)
      out.push(p)
    }
  }
  for (const slug of post.internal_links) push(getPostBySlug(slug))
  for (const p of posts) {
    if (out.length >= limit) break
    if (p.category === post.category) push(p)
  }
  for (const p of posts) {
    if (out.length >= limit) break
    if (p.tags.some((t) => post.tags.includes(t))) push(p)
  }
  return out.slice(0, limit)
}
